import { MgpPayload } from "@earned/wizard/dist";
import { useMutationFormeBackendApi } from "@modules/forme/queries";

const useUpdateMgpInfo = () => {
  return useMutationFormeBackendApi<void, { data: MgpPayload }>({
    method: "PUT",
    path: "/v1/clients/intake/money-guide-pro",
  });
};

export { useUpdateMgpInfo };
